import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const ExceptionsFallback = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Skeleton className="h-5.5 w-55 mb-0.5" />
        </CardTitle>
        <CardAction>
          <Skeleton className="h-9 w-36.5" />
        </CardAction>
        <CardDescription className="space-y-1">
          <Skeleton className="h-5 w-200" />
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Skeleton className="h-6 w-60" />
      </CardContent>
    </Card>
  )
}
